export const AMOUNT_DECIMAL = 6;
export const PRICE_DECIMAL = 2;
export const PRICE_DECIMAL_S = 6;
export const FEE_DECIMAL = 2;

export const getPriceDecimal = (price: number) => {
  return price < 10 ? PRICE_DECIMAL_S : PRICE_DECIMAL;
};
